// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3RhZo","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3bN4p"};